import React, { Component } from 'react'
import styled from 'styled-components'

import ArrowIcon from './images/ic-arrow.component.svg'

class DropdownV2 extends Component {
  constructor(props) {
    super(props)
    // Initial state: dropdown is closed
    this.state = {
      isOpen: props.isOpen || false,
    }
  }

  // Toggle the dropdown open/close state
  toggleDropdown = () => {
    this.setState((prevState) => ({
      isOpen: !prevState.isOpen,
    }))
  }

  render() {
    const { title, children, style } = this.props
    const { isOpen } = this.state

    return (
      <Wrapper style={style}>
        <ClickableArea
          onClick={this.toggleDropdown}
          onKeyDown={this.toggleDropdown}
          role='combobox'
          aria-haspopup={true}
          tabIndex={0}
          aria-labelledby='dropdown-label'
          aria-expanded={isOpen}
          aria-controls='dropdown-content-id'>
          <h3>{title}</h3>
          <Arrow isOpen={isOpen}>
            <ArrowIcon />
          </Arrow>
        </ClickableArea>

        {isOpen && (
          <Content
            id='dropdown-content-id'
            role='listbox'
            aria-labelledby='dropdown-label'>
            {children}
          </Content>
        )}
      </Wrapper>
    )
  }
}

export default DropdownV2

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
`

const ClickableArea = styled.div`
  display: flex;
  height: 32px;
  padding: 12px 6px;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  cursor: pointer;

  h3 {
    color: #3e3e3e;
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: Nunito;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
    text-transform: none;
    text-align: left;
    margin: 0;
  }

  &:hover {
    background-color: #fcfcfc;
  }

  &:focus {
    border: 1px solid #5c5c5c;
  }
`

const Arrow = styled.span`
  width: 24px;
  height: 24px;
  transition: transform 0.1s ease-in;

  ${({ isOpen }) =>
    !isOpen &&
    `
    transform: rotate(180deg);
  `}
`

const Content = styled.div`
  width: 100%;
`



// WEBPACK FOOTER //
// ./src/components/DropdownV2/index.js